import { render, staticRenderFns } from "./OrderServicesRequestDates.vue?vue&type=template&id=223c3c27&scoped=true&"
import script from "./OrderServicesRequestDates.vue?vue&type=script&lang=js&"
export * from "./OrderServicesRequestDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223c3c27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('223c3c27')) {
      api.createRecord('223c3c27', component.options)
    } else {
      api.reload('223c3c27', component.options)
    }
    module.hot.accept("./OrderServicesRequestDates.vue?vue&type=template&id=223c3c27&scoped=true&", function () {
      api.rerender('223c3c27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/OfferPresentation/Partial/OrderServicesRequestDates.vue"
export default component.exports